import { PassportStrategy } from '@nestjs/passport';
import { ExtractJwt, Strategy } from 'passport-jwt';
import {Injectable} from '@nestjs/common';
import {AuthService} from './auth.service';
import {UserDto} from '../user/dto/user.dto'
import {JwtPayload} from './jwt.payload';
require('dotenv').config();
@Injectable()
export class JwtStrategy extends PassportStrategy(Strategy) { 
    constructor(private readonly authService: AuthService) {
         super(
          {
            jwtFromRequest: ExtractJwt.fromAuthHeaderAsBearerToken(),
            secretOrKey: 'ramakrishna',//process.env.SECRETKEY,
        }
        );  
        console.log(process.env.KEY);
    }
   
    async validate(payload: JwtPayload): Promise<UserDto> {
        const user = await this.authService.validateUser(payload);
        if (!user) {
            throw 'new HttpException(Invalid token, HttpStatus.UNAUTHORIZED)';    
        }    
        return user;  
    }
}
